/**
 * <s-sticky-buy-bar> — mobile bar that slides in once the main add-to-cart leaves the viewport.
 *
 * Watches the first [data-main-atc] in the document. Sets [data-visible] on itself
 * while that button is scrolled past (above the viewport), and mirrors visibility to
 * aria-hidden/inert so the hidden bar is never reachable. The bar's own submit button
 * targets the product form via the form attribute, so quantity and bundle tier carry over.
 */
class SStickyBuyBar extends HTMLElement {
  #observer;

  connectedCallback() {
    const target = document.querySelector('[data-main-atc]');
    this.#setVisible(false);
    if (!target || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.#setVisible(scrolledPast);
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #setVisible(visible) {
    this.toggleAttribute('data-visible', visible);
    this.setAttribute('aria-hidden', String(!visible));
    this.inert = !visible;
    for (const button of this.querySelectorAll('button')) {
      button.tabIndex = visible ? 0 : -1;
    }
  }
}

if (!customElements.get('s-sticky-buy-bar')) {
  customElements.define('s-sticky-buy-bar', SStickyBuyBar);
}
